import * as React from "react"
export const Svg_069 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M0 10.835h7.49v37.33H0v-37.33Z" />
    <path fill="url(#b)" d="M10.947 19.247h4.61v20.506h-4.61V19.247Z" />
    <path fill="url(#c)" d="M43.443 19.247h4.61v20.506h-4.61V19.247Z" />
    <path fill="url(#d)" d="M51.51 10.835H59v37.33h-7.49v-37.33Z" />
    <path fill="url(#e)" d="M19.014 23.738h20.972v11.524H19.014V23.738Z" />
    <defs>
      <linearGradient
        id="a"
        x1={1.732}
        x2={13.381}
        y1={16.434}
        y2={20.217}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={12.013}
        x2={19.011}
        y1={22.323}
        y2={24.868}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={44.509}
        x2={51.507}
        y1={22.323}
        y2={24.868}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={53.242}
        x2={64.891}
        y1={16.434}
        y2={20.217}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={23.864}
        x2={27.59}
        y1={25.467}
        y2={36.443}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)